export type MeResponse = { authenticated: boolean; roles: string[]; claims: any | null; debug?: any }

export const useAuth = () => {
  const me = useState<MeResponse>('auth.me', () => ({ authenticated: false, roles: [], claims: null }))
  const loaded = useState<boolean>('auth.loaded', () => false)
  const csrf = useCookie<string | null>('csrf')

  const fetchMe = async () => {
    const headers = process.server ? useRequestHeaders(['cookie']) : undefined
    const { data } = await useFetch<MeResponse>('/api/auth/me', { headers, credentials: 'include' })
    me.value = data.value || { authenticated: false, roles: [], claims: null }
    loaded.value = true
  }

  const ensureLoaded = async () => { if (!loaded.value) await fetchMe() }
  const hasRole = (r: string) => (me.value.roles || []).includes(r)
  const hasAnyRole = (roles: string[]) => roles.some(r => hasRole(r))

  return { me, loaded, csrf, fetchMe, ensureLoaded, hasRole, hasAnyRole }
}
//   const isAuthenticated = computed(() => !!me.value?.authenticated)
